import {ContactsProps} from "../../../../../components/contacts/types";
import React from "react";
import {SocialProps} from "../../../../../components/social/types";
import {ContactsAndSocialProps} from "../../../../../components/contacts-and-social/types";
import VkIcon from "../../../../../images/svg/VK.svg";
import TelegramIcon from "../../../../../images/svg/Telegram.svg";
import {Translate} from "../../../../../locales/locales-utils";

const socialProps = (): SocialProps => {
    return  {
        title: Translate("Global.Footer.SocialTitle"),
        elements: [
            {
                img: (
                    <img
                        src={VkIcon}
                        width={48}
                        height={48}
                        alt=""
                    />
                ),
                href: "https://vk.com/myquizz",
            },
            {
                img: (
                    <img
                        src={TelegramIcon}
                        width={48}
                        height={48}
                        alt=""
                    />
                ),
                href: "https://t.me/myquizz",
            }
        ]
    }
};

const contactsProps: ContactsProps = {
    support: {
        href: "mailTo:hello@myquiz.ru",
        text: "hello@myquiz.ru",
    },
    phone: {
        href: "tel:+78123172254",
        text: "+7 (812) 317-22-54 ",
    },
};

export const contactsAndSocialProps = (): ContactsAndSocialProps => {
    return {
        socialProps: socialProps(),
        contactsProps
    }
}
